<template>
  <section class="container">
    <layout-breadcrumb :items="breadcrumbs"></layout-breadcrumb>
    
    <div class="row">
      <div class="col-md-12 mb-3">
        <h2 class="font-weight-800 text-transparencia">
          ESCUELA DE OBSERVADORES DEMOCRÁTICOS
        </h2>
      </div>
    </div>
    
    <!-- Loading State -->
    <div v-if="cargando" class="row justify-content-center">
      <div class="col-md-10">
        <div class="card">
          <div class="card-body text-center p-5">
            <div class="spinner-border text-transparencia" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-3 text-muted">Cargando información...</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="row justify-content-center">
      <div class="col-md-10">
        <div class="card">
          <div class="card-body text-center p-5">
            <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <h5 class="text-muted">Error al cargar la información</h5>
            <p class="text-muted">{{ errorMessage }}</p>
            <button @click="fetchData" class="btn btn-outline-primary">
              <i class="fa fa-refresh mr-1"></i> Reintentar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div v-else-if="datos && Object.keys(datos).length > 0" class="row justify-content-center">
      <div class="col-md-10">
        <div class="card">
          <div class="card-header bg-transparencia text-white">
            <h4 class="mb-0">
              <i class="fa fa-graduation-cap mr-2"></i>
              {{ datos.tituloGeneral || 'Escuela de Observadores Democráticos' }}
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h5 class="text-transparencia mb-3">
                  <i class="fa fa-info-circle mr-2"></i>
                  {{ datos.tituloDescripcion || '¿Qué es la Escuela?' }}
                </h5>
                <div class="text-justify" v-html="datos.descripcionContenido || 'Contenido no disponible'"></div>
              </div>
              <div class="col-md-6">
                <h5 class="text-transparencia mb-3">
                  <i class="fa fa-trophy mr-2"></i>
                  {{ datos.tituloBeneficio || 'Beneficios del Programa' }}
                </h5>
                <div class="text-justify" v-html="datos.descripcionBeneficio || 'Beneficios no disponibles'"></div>
              </div>
            </div>
            
            <hr class="my-4">
            
            <!-- Actividades -->
            <div class="row" v-if="datos.actividades && datos.actividades.length > 0">
              <div class="col-md-12">
                <h5 class="text-transparencia mb-3">
                  <i class="fa fa-calendar mr-2"></i>
                  Próximas Actividades
                </h5>
                <div class="row">
                  <div v-for="(actividad, index) in datos.actividades" :key="index" class="col-md-4 mb-3">
                    <div class="card border-primary">
                      <div class="card-body text-center">
                        <div class="mb-3">
                          <i v-if="actividad.iconoHtmlValue" :class="`fa fa-${actividad.iconoHtmlValue} fa-3x text-transparencia`"></i>
                          <img v-else-if="actividad.icono" :src="`${filesUrl}${actividad.icono}`" class="img-fluid" style="max-height: 60px;" alt="Icono actividad" />
                          <i v-else class="fa fa-graduation-cap fa-3x text-transparencia"></i>
                        </div>
                        <h6 class="card-title">{{ actividad.titulo || `Actividad ${index + 1}` }}</h6>
                        <p class="card-text small">{{ actividad.descripcion || 'Descripción no disponible' }}</p>
                        <a v-if="actividad.link" :href="actividad.link" target="_blank" class="btn btn-outline-primary btn-sm">
                          {{ actividad.textoBtn || 'Ver más' }}
                        </a>
                        <span v-else class="btn btn-outline-primary btn-sm disabled" style="cursor: default;">
                          {{ actividad.textoBtn || 'Próximamente' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <hr class="my-4">
            
            <!-- Call to Action -->
            <div class="row">
              <div class="col-md-12 text-center">
                <h5 class="text-transparencia mb-3">
                  {{ datos.tituloRedireccion || '¿Interesado en participar?' }}
                </h5>
                <p class="mb-4" v-html="datos.textoRedireccion || 'Si deseas formar parte de la Escuela de Observadores Democráticos, contáctanos para obtener más información sobre los próximos programas de formación.'"></p>
                <router-link to="/voluntariado/escuela-observadores-democraticos/modulos" class="btn btn-transparencia btn-lg">
                  <i class="fa fa-paper-plane mr-2"></i>
                  {{ datos.textoBtnRedireccion || 'Iniciar formación' }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Data State -->
    <div v-else class="row justify-content-center">
      <div class="col-md-10">
        <div class="card">
          <div class="card-body text-center p-5">
            <i class="fa fa-graduation-cap fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">No hay información disponible</h5>
            <p class="text-muted">La información de la Escuela de Observadores Democráticos no está configurada</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";

export default {
  name: "view-escuela-observadores-democraticos",
  metaInfo: {
    title: "Escuela de Observadores Democráticos",
  },
  components: { 
    layoutBreadcrumb
  },
  data: () => ({
    datos: {},
    cargando: false,
    error: false,
    errorMessage: '',
    breadcrumbs: []
  }),
  methods: {
    async fetchData() {
      this.cargando = true;
      this.error = false;
      
      try {
        const response = await this.$http.get(this.apiRoute("Volunteering", "GetVoluntariadoEodDetail"));
        
        if (!response.body.error) {
          this.datos = response.body.data || {};
        } else {
          this.error = true;
          this.errorMessage = response.body.message || 'Error al cargar los datos';
        }
      } catch (error) {
        this.error = true;
        this.errorMessage = 'Error de conexión al servidor';
      } finally {
        this.cargando = false;
      }
    }
  },
  mounted: async function() {
    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Voluntariado", url: "/voluntariado", icon: "", active: false },
      { name: "Escuela de Observadores Democráticos", url: "", icon: "", active: true },
    ];
    
    await this.fetchData();
  },
};
</script>

<style scoped>
.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.bg-transparencia {
  background-color: #2484da !important;
}

.text-transparencia {
  color: #2484da !important;
}

.btn-transparencia {
  background-color: #2484da !important;
  border-color: #2484da !important;
  color: white !important;
}

.btn-transparencia:hover {
  background-color: #1e6bb8 !important;
  border-color: #1e6bb8 !important;
}

.border-primary {
  border-color: #2484da !important;
}

.badge-primary {
  background-color: #2484da !important;
}

/* Responsive */
@media (max-width: 768px) {
  .container .row {
    margin-left: -15px;
    margin-right: -15px;
  }
  
  .container .col-md-12,
  .container .col-md-10,
  .container .col-md-6,
  .container .col-md-4 {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
